import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Section } from '@app/models/help/section.model';

@Injectable({ providedIn: "root" })
export class SectionService {

  private service = 'SectionService';

  constructor(private http: HttpClient) {

  }

  public getListWithQuestions() {
    return this.http.get<Section[]>(`api/${this.service}/list-with-questions`);
  }

  public getList(): any {
    return this.http.get(`api/${this.service}/list`);
  }

  public insert(section: Section) {
    return this.http.post(`api/${this.service}/insert`, section);
  }

  public update(section: Section) {
    return this.http.put(`api/${this.service}/update`, section);
  }

  public delete(id) {
    return this.http.delete(`api/${this.service}/delete/${id}`);
  }
}
